import { gql } from '@apollo/client';

const AUTOMATION_FIELDS = gql`
    fragment AutomationFields on automations {
        automation_id
        key
        url
        crontab
        timezone
        shipper_id
        carrier_id
        middle_mile_carrier_id
        params
        body
        created_at
        last_modified_at
    }
`;

export const QUERY_AUTOMATIONS = gql`
    ${AUTOMATION_FIELDS}
    query AdminAutomations {
        automations(order_by: [{ url: asc }, { created_at: asc }]) {
            ...AutomationFields
        }
    }
`;

export const QUERY_AUTOMATION_CLIENTS = gql`
    query AdminAutomationClients {
        clients {
            client_id
            business_name
            user {
                user_id
                roles
            }
        }
    }
`;

export const INSERT_AUTOMATION = gql`
    ${AUTOMATION_FIELDS}
    mutation InsertAutomation($object: automations_insert_input!) {
        insert_automations_one(object: $object) {
            ...AutomationFields
        }
    }
`;

export const UPDATE_AUTOMATION = gql`
    ${AUTOMATION_FIELDS}
    mutation UpdateAutomation($automation_id: uuid!, $update: automations_set_input!) {
        update_automations_by_pk(pk_columns: { automation_id: $automation_id }, _set: $update) {
            ...AutomationFields
        }
    }
`;

export const DELETE_AUTOMATION = gql`
    mutation DeleteAutomation($automation_id: uuid!) {
        delete_automations_by_pk(automation_id: $automation_id) {
            automation_id
        }
    }
`;
